import { axiosWrapper } from "../../axiosWrapper";

export class UserProvisiongService {
  public static async getAccessConfiguration() {
    return await axiosWrapper.Get(`AccessProvision/GetAccessConfigurations`);
  }
}
